import { Alert, Button, EmptyState } from '@indipia/ui-core'

// D-09 §15.10 Alert(.alert-error) — 스케줄러 전역에서 "요청 실패" 배너를 통일해 보여주기 위한 래퍼.
// message/onRetry 시그니처는 그대로 유지해 기존 13개 호출부를 그대로 둔다.
export interface ErrorBannerProps {
  message?: string
  onRetry?: () => void
}

export function ErrorBanner({ message = '정보를 불러오지 못했습니다.', onRetry }: ErrorBannerProps) {
  return (
    <Alert
      kind="error"
      role="alert"
      action={onRetry && <Button variant="etc" size="sm" onClick={onRetry}>다시 시도</Button>}
    >
      {message}
    </Alert>
  )
}

// D-09 §15.37 — 빈 상태(.state-block). 스케줄러 내 사용처가 없어 그대로 재노출만 한다.
export { EmptyState }
